import { network } from 'services/network';

export const bulkAssignToUser = (params) => {
    return network
        .post('api/bo/bulkAssignToUser', params)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};
